"use client";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function SkipToMainContent() {
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-brand focus:px-4 focus:py-2 focus:text-white"
      suppressHydrationWarning
    >
      {mounted ? t("web.ui.skipToMain") : ""}
    </a>
  );
}
